export default __webpack_public_path__ + "static/SELFLOVEALWAYS_PINK-ee32dc55629755365b0ab9dd30f64895.png";